export default [
    {
        path: '/login',
        component: resolve => require(['../view/Login/Login.vue'], resolve)
    },
]



// WEBPACK FOOTER //
// ./src/router/auth.js